module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[5]4.dea320a.woff2";